import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Input, version2 } from 'ui-components/components/input';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { CREDIT_CARD_FIELDS } from '../constants';
import { useCreditCardContext } from '../credit-card-context-provider';
import { useCreditCardField } from '../use-credit-card-field';

export const CreditCardInput = ({ field, ignoreError = false, ...rest }) => {
  const intl = useIntl();
  const { disabled, showAllErrors } = useCreditCardContext();

  const { value, onChange, onBlur, error, labelDescriptor, placeholderDescriptor, touched } = useCreditCardField(field);

  const _onChange = useCallback(
    (event) => {
      onChange(event?.target?.value);
    },
    [onChange],
  );

  const _onBlur = useCallback(
    (event) => {
      onBlur(event?.target?.value);
    },
    [onBlur],
  );

  const shouldShowErrors = !ignoreError && (touched || showAllErrors);
  const inlineMessage = shouldShowErrors && error?.message;
  const inlineMessageType = inlineMessage ? INLINE_MESSAGE_TYPES.error : undefined;

  const label = labelDescriptor && intl.formatMessage(labelDescriptor);
  const placeholder = placeholderDescriptor && intl.formatMessage(placeholderDescriptor);

  return (
    <Input
      aria-labelledby={field}
      disabled={disabled}
      id={field}
      inlineMessage={inlineMessage}
      inlineMessageType={inlineMessageType}
      label={label}
      name={field}
      onBlur={_onBlur}
      onChange={_onChange}
      placeholder={placeholder}
      value={value}
      version={version2}
      {...rest}
    />
  );
};

CreditCardInput.propTypes = {
  field: PropTypes.oneOf(Object.values(CREDIT_CARD_FIELDS)).isRequired,
  ignoreError: PropTypes.bool,
};
